export default __webpack_public_path__ + "static/media/banner-informativo-info-pagamento.977b4ebf.png";